import { isDesktop } from "react-device-detect";
import { DesktopPage } from "./DesktopPage";
import { MobilePage } from "./MobilePage";
import { useEffect, useState } from "react";
import { CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useUser } from "../../context/UserContext";

export const WelcomePage = ({ onFinish }) => {
  const { t } = useTranslation("homeModule");
  const { getRegion } = useUser();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    getRegion().then(() => setIsLoading(false));
  }, []);

  return (
    <>
      {isLoading ? (
        <div className="home-loading-page">
          <CircularProgress
            disableShrink
            color="inherit"
            size={40}
            thickness={4}
          />
          <p className="loading-text">{t("initializing")}...</p>
        </div>
      ) : isDesktop ? (
        <DesktopPage />
      ) : (
        <MobilePage onFinish={onFinish} />
      )}
    </>
  );
};
